<template>
  <div>
    <Auth v-if="!$store.state.is_admin" />
    <div v-else>
      <Apartments />
    </div>
  </div>
</template>

<script>
import Apartments from "./Apartments";
import Auth from "@/components/admin/Auth";

export default {
  components: {
    Auth,
    Apartments,
  },
};
</script>

